'use client';

import { Badge, IconButton, MonoDefault } from '@terra/ui-design-system';
import { Box, HStack } from '@terra/ui-styled-system';
import { Delete02Icon } from '@terra/ui-icons';
import type {
  TerminalApprovalRule,
  TerminalApprovalRuleAction,
} from '@terra/shared-dto-chat-types';

type TerminalApprovalRuleRowProps = {
  rule: TerminalApprovalRule;
  actionLabel: string;
  removeLabel: string;
  onRemove: () => void;
};

const ACTION_FG: Record<TerminalApprovalRuleAction, string> = {
  allow: 'fg.decorative.green',
  ask: 'fg.decorative.yellow',
  deny: 'fg.decorative.red',
};

const ACTION_BORDER: Record<TerminalApprovalRuleAction, string> = {
  allow: 'border.decorative.green',
  ask: 'border.decorative.yellow',
  deny: 'border.decorative.red',
};

export function TerminalApprovalRuleRow({
  rule,
  actionLabel,
  removeLabel,
  onRemove,
}: TerminalApprovalRuleRowProps) {
  return (
    <HStack
      gap={2}
      px={2}
      py={1}
      borderRadius="md"
      justifyContent="space-between"
      _hover={{ bg: 'bg.subtle' }}
    >
      <HStack gap={2} minW={0}>
        <Badge
          variant="outline"
          size="xs"
          color={ACTION_FG[rule.action]}
          borderColor={ACTION_BORDER[rule.action]}
        >
          {actionLabel}
        </Badge>
        <Box minW={0} truncate>
          <MonoDefault>{rule.pattern}</MonoDefault>
        </Box>
      </HStack>
      <IconButton
        variant="ghost"
        size="xs"
        aria-label={removeLabel}
        onClick={onRemove}
      >
        <Delete02Icon size={14} />
      </IconButton>
    </HStack>
  );
}
